import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_inventory_by_lotReceivedDateService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectIds?: number[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, TotalAmount?: number, Lot?: { LookupCode?: string, ReceiveDate?: string }, Material?: { Description?: string, LookupCode?: string, Project?: { Name?: string, Owner?: { Name?: string } } }, Packaging?: { Name?: string, ShortName?: string }, LicensePlate?: { LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_by_lotReceivedDate/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, TotalAmount?: number, Lot?: { LookupCode?: string, ReceiveDate?: string }, Material?: { Description?: string, LookupCode?: string, Project?: { Name?: string, Owner?: { Name?: string } } }, Packaging?: { Name?: string, ShortName?: string }, LicensePlate?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_by_lotReceivedDate/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectIds?: number[], $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, TotalAmount?: number, Lot?: { LookupCode?: string, ReceiveDate?: string }, Material?: { Description?: string, LookupCode?: string, Project?: { Name?: string, Owner?: { Name?: string } } }, Packaging?: { Name?: string, ShortName?: string }, LicensePlate?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_inventory_by_lotReceivedDate/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
